import React from 'react';
import { Link } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faMapMarkerAlt, faShoppingCart, faStar, faGift, faPhone, faClock } from '@fortawesome/free-solid-svg-icons';

const VisiGiftStores = () => {
  return (
    <div className="min-h-screen flex flex-col bg-gray-50 text-gray-900 font-sans">
      {/* Header */}
      <header className="bg-white shadow-sm border-b border-gray-200 px-4 py-3 sticky top-0 z-10">
        <div className="flex flex-col items-center text-center">
          <h1 className="text-xl font-bold text-gray-800">Mahavir Corner Store</h1>
          <div className="flex items-center justify-center gap-1 text-sm text-gray-600 mt-1">
            <FontAwesomeIcon icon={faMapMarkerAlt} className="text-xs" />
            <span>Palava, Dombivli East, Thane, Mumbai</span>
          </div>
        </div>
      </header>

      {/* Hero Section */}
      <main className="flex-grow">
        <section className="bg-gradient-to-br from-gray-100 to-gray-200 px-4 py-6 text-center">
          <div className="max-w-md mx-auto">
            <img
              src="/api/downloads/ads/mahavir-store.jpg" // Placeholder for store image
              alt="Mahavir Corner Store"
              className="w-full h-48 object-cover rounded-lg shadow-md mb-4"
            />
            <p className="text-sm text-gray-700 mb-4">
              Your friendly neighborhood grocery store offering fresh produce, daily essentials, and household needs. Open daily for convenient shopping!
            </p>
            <div className="flex items-center justify-center gap-2 text-yellow-500 mb-4">
              <FontAwesomeIcon icon={faStar} />
              <FontAwesomeIcon icon={faStar} />
              <FontAwesomeIcon icon={faStar} />
              <FontAwesomeIcon icon={faStar} />
              <FontAwesomeIcon icon={faStar} />
              <span className="text-sm text-gray-600">4.8 (128 reviews)</span>
            </div>
          </div>
        </section>

        {/* Store Info */}
        <section className="px-4 py-4 bg-white">
          <div className="max-w-md mx-auto space-y-3">
            <div className="flex items-center gap-3 p-3 bg-gray-50 rounded-lg">
              <FontAwesomeIcon icon={faClock} className="text-gray-500" />
              <div>
                <h3 className="font-medium text-gray-800">Hours</h3>
                <p className="text-sm text-gray-600">Mon-Sun: 7 AM - 10 PM</p>
              </div>
            </div>
            <div className="flex items-center gap-3 p-3 bg-gray-50 rounded-lg">
              <FontAwesomeIcon icon={faPhone} className="text-gray-500" />
              <div>
                <h3 className="font-medium text-gray-800">Contact</h3>
                <p className="text-sm text-gray-600">+91 98765 43210</p>
              </div>
            </div>
            <div className="flex items-center gap-3 p-3 bg-gray-50 rounded-lg">
              <FontAwesomeIcon icon={faMapMarkerAlt} className="text-gray-500" />
              <div>
                <h3 className="font-medium text-gray-800">Address</h3>
                <p className="text-sm text-gray-600">Shop No. 5, Palava Central, Dombivli East, Thane - 421204</p>
              </div>
            </div>
          </div>
        </section>

        {/* VisiGift Integration - Earn Points */}
        <section className="px-4 py-6 bg-gray-100">
          <h2 className="text-lg font-semibold text-center mb-4 text-gray-800">Earn Rewards with VisiGift</h2>
          <p className="text-sm text-gray-600 text-center mb-6 max-w-md mx-auto">
            Discover our store through rewarding ads! Earn points by engaging below and redeem for discounts on your next shop.
          </p>
          <div className="grid grid-cols-2 gap-3 max-w-md mx-auto">
            <Link
              to="/visigift-ad-view"
              className="flex flex-col items-center p-4 bg-white rounded-lg shadow-sm hover:shadow-md transition-shadow text-center"
            >
              <FontAwesomeIcon icon={faGift} className="text-2xl text-gray-600 mb-2" />
              <span className="text-sm font-medium text-gray-800">View Ad</span>
              <span className="text-xs text-gray-500">Earn 10 points</span>
            </Link>
            <Link
              to="/visigift-shop-now"
              className="flex flex-col items-center p-4 bg-white rounded-lg shadow-sm hover:shadow-md transition-shadow text-center"
            >
              <FontAwesomeIcon icon={faShoppingCart} className="text-2xl text-gray-600 mb-2" />
              <span className="text-sm font-medium text-gray-800">Shop Now</span>
              <span className="text-xs text-gray-500">Earn 5 points</span>
            </Link>
          </div>
          <div className="text-center mt-4">
            <Link
              to="/visigift-redeem"
              className="inline-block bg-gray-800 text-white px-4 py-2 rounded-md text-sm hover:bg-gray-700 transition-colors"
            >
              Redeem Points
            </Link>
          </div>
        </section>

        {/* Featured Products */}
        <section className="px-4 py-4 bg-white">
          <h2 className="text-lg font-semibold mb-4 text-gray-800">Featured Products</h2>
          <div className="grid grid-cols-2 gap-3 max-w-md mx-auto">
            <div className="bg-gray-50 p-3 rounded-lg text-center">
              <img
                src="/api/downloads/products/fresh-veggies.jpg" // Placeholder
                alt="Fresh Veggies"
                className="w-full h-20 object-cover rounded mb-2"
              />
              <p className="text-sm text-gray-800">Fresh Veggies</p>
              <p className="text-xs text-gray-500">₹50/kg</p>
            </div>
            <div className="bg-gray-50 p-3 rounded-lg text-center">
              <img
                src="/api/downloads/products/dairy.jpg" // Placeholder
                alt="Dairy Products"
                className="w-full h-20 object-cover rounded mb-2"
              />
              <p className="text-sm text-gray-800">Dairy</p>
              <p className="text-xs text-gray-500">₹40/ltr</p>
            </div>
            <div className="bg-gray-50 p-3 rounded-lg text-center">
              <img
                src="/api/downloads/products/snacks.jpg" // Placeholder
                alt="Snacks"
                className="w-full h-20 object-cover rounded mb-2"
              />
              <p className="text-sm text-gray-800">Snacks</p>
              <p className="text-xs text-gray-500">₹20/pack</p>
            </div>
            <div className="bg-gray-50 p-3 rounded-lg text-center">
              <img
                src="/api/downloads/products/household.jpg" // Placeholder
                alt="Household Essentials"
                className="w-full h-20 object-cover rounded mb-2"
              />
              <p className="text-sm text-gray-800">Essentials</p>
              <p className="text-xs text-gray-500">₹100/set</p>
            </div>
          </div>
        </section>

        {/* Call to Action */}
        <section className="px-4 py-6 bg-gray-100 text-center">
          <h2 className="text-lg font-semibold mb-2 text-gray-800">Visit Us Today!</h2>
          <p className="text-sm text-gray-600 mb-4">Get 10% off on your first purchase with VisiGift points.</p>
          <Link
            to="/visigift-navigate"
            className="inline-block bg-gray-800 text-white px-6 py-3 rounded-md text-sm hover:bg-gray-700 transition-colors"
          >
            Get Directions
          </Link>
        </section>
      </main>

      {/* Footer */}
      <footer className="bg-gray-800 text-gray-300 px-4 py-4 text-center text-sm">
        <p>&copy; 2025 Mahavir Corner Store. Powered by VisiGift.</p>
        <div className="flex justify-center gap-4 mt-2">
          <Link to="/privacy-policy" className="hover:text-white">Privacy</Link>
          <Link to="/terms" className="hover:text-white">Terms</Link>
          <Link to="/contact" className="hover:text-white">Contact</Link>
        </div>
      </footer>
    </div>
  );
};

export default VisiGiftStores;